import { EuiFlexItem, EuiFlexGroup, EuiButton } from "@elastic/eui";
import React,{ useMemo, useRef } from "react";
import ListaDelegadosContainer from "../../../components/Listas/DelegadosSeleccion";
import ModalApp from "../../../components/Modal";


interface Props{
    isOpen:boolean;
    user:any;
    onClose():void;
    onAddDelegados(centros:string):void;
}

export const ModalSelectorDelegados = (props:Props) =>{
    const ref:any = useRef();
    const {isOpen,user,onAddDelegados,onClose} = props;
    
    const content = useMemo(() => (isOpen===true ? <ListaDelegadosContainer ref={ref} user={user}/> : <></>),[isOpen])
    

    const onSave = () =>{
        const dataSave = ref.current && ref.current.onSave();
        onAddDelegados(dataSave.toString())
    }

    const footer = (
        <EuiFlexGroup>
            <EuiFlexItem>
                <EuiButton onClick={()=>onSave()}>Guardar</EuiButton>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    )

    return <ModalApp isOpen={isOpen} title='Selector De Usuarios Delegados' content={content} contentFooter={footer} onClose={onClose}/>
}